import React from "react";
import {ServiceEvent} from "crqlar-react-common/dist/models/agenda/agenda.types";
import {formatDateHM} from "crqlar-react-common/dist/utils/date.util";

interface Props {
    event: ServiceEvent;
    onOpen: (e: ServiceEvent) => void;
    locale: Record<string, string>;
}

const AgendaEventItem: React.FC<Props> = ({event, locale}) => {
    const reservationCount = event.event.reservationCount;
    const barColor = event.color ?? '#9e9e9e';

    const startTime = new Date(event.start as string);
    const endTime = new Date(event.end as string);
    const isDisabled = startTime.getTime() < Date.now();

    const timeRange = `${formatDateHM(startTime)} - ${formatDateHM(endTime)}`;

    const reservationText =
        reservationCount > 0
            ? `${reservationCount} ${
                reservationCount > 1
                    ? locale["Reservations"] || "Reservations"
                    : locale["Reservation"] || "Reservation"
            }`
            : locale["No Reservations yet"] || "No Reservations yet";


    return (
        <div
            className={`agenda-event${isDisabled ? " disabled" : ""}`}
            style={{
                ["--agenda-event-bar" as any]: barColor,
                opacity: isDisabled ? 0.5 : 1
            }}
            role="button"
            tabIndex={isDisabled ? -1 : 0}
            aria-disabled={isDisabled}
        >
            <div className="agenda-event__bar"/>
            <div className="agenda-event__content">
                <div className="agenda-event__title"
                     title={event.title || event.original?.serviceName}>
                    {event.title || event.original?.serviceName || "Service"}
                </div>
                <div className="agenda-event__desc">
                    <div className="agenda-event__desc-left">{reservationText}</div>
                    <div className="agenda-event__desc-right">{timeRange}</div>
                </div>
            </div>
        </div>
    );
};

export default AgendaEventItem;